export const eventTypes = {
  USER_SIGNUP: 'User Signup',
  USER_LOGIN: 'User Login',
}
